import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import { useNavigate, useLocation } from "react-router-dom";
import DynamicForm from "../../../../customformComponent/customForm/DynamicForm";
import backicon from "./../../../../../Assets/icons/backIcon.svg";
import ROUTES_NAVIGATION from "../../../../../routes/routes";
import axiosInstance from "../../../../services/api/API";
import { showCustomAlert } from "../../../../customComponents/CustomSweetAlert";
import { buttonStyle, isFormValid } from "../../../../../helpers/common";
import Loader from "../../../../customComponents/CustomLoader";
import validations from "../../../../../helpers/validations";

const EditTerm = () => {
  const [formData, setFormData] = useState({});
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const navigate = useNavigate();
  const [editTermset, setEditTermset] = useState([]);
  const location = useLocation();
  const authToken = localStorage.getItem("authToken");
  const [isLoading, setIsLoading] = useState(false);
  const [userTypedd, setUserTypedd] = useState([]);

  const [validationErrors, setValidationErrors] = useState({});
  const userType = localStorage.getItem("UserType");
  const businessPartnerId = localStorage.getItem("businessPartnerId");
  const { rowData } = location.state || {};

  const TermInputs = [
    ...(userType === "superadmin"
      ? [
          {
            name: "business_partner_id",
            label: "Business Partner",
            type: "dropdown",
            required: true,
            options: userTypedd,
            gridClass: "col-lg-4",
            validation: validations.businessPartnerId({ required: true }),
          },
        ]
      : []),
    {
      name: "term_name",
      label: "Termset Name",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: validations.termName({ required: true }),
      // validation: {
      //   required: true,
      //   maxLength: 40,
      //   message:
      //     "Termset Name must be 5–40 characters long, without spaces, and may contain only letters, numbers, and the special characters - / ! &",
      // },
    },
    {
      // name: "status",
      // label: "Status",
      // type: "dropdown",
      // required: true,
      // options: [
      //   { label: "Active", value: "Active" },
      //   { label: "Inactive", value: "Inactive" },
      // ],
      // validation: {
      //   required: true,
      //   message: "Status is required",
      // },
       name: "status",
      label: "Status",
      type: "toggle",
      gridClass: "col-lg-4",
    },

    {
      name: "term_desc",
      label: "Description",
      type: "richeditor",
      gridClass: "col-lg-12",
      validation: { required: true },
    },
  ];
  useEffect(() => {
    userTypedropdown();
  }, []);

  const userTypedropdown = async () => {
    try {
      const response = await axiosInstance.get("/bp-onboard/bplist", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      const data = response.data.data.data;
      const userTypeOptions = data.map((user) => ({
        value: user.onboard_id,
        label: user.bp_name,
      }));
      setUserTypedd(userTypeOptions);
    } catch (error) {
      console.error(error);
    }
  };

  const handleFormSubmit = async (formData) => {
    const errors = {};
    let isValid = true;

    // Form validation

    TermInputs.forEach((field) => {
      if (field.required && !formData[field.name]) {
        errors[field.name] = "This field is required";
        isValid = false;
      }
      if (
        field.validation?.pattern &&
        !field.validation.pattern.test(formData[field.name])
      ) {
        errors[field?.name] = field?.validation?.message;
        isValid = false;
      }
    });

    if (!isValid) {
      setValidationErrors(errors);
      return;
    }

    setIsLoading(true);

    try {
      // Display confirmation dialog before proceeding
      const confirmation = await Swal.fire({
        title: "Are you sure?",
        text: "Do you really want to update this record?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "Cancel",
        allowOutsideClick: false,
        allowEscapeKey: false,
      });

      // If the user cancels, exit early
      if (!confirmation.isConfirmed) {
        setIsLoading(false); // Reset loading state
        return;
      }

      // Perform API call to submit form data
      const response = await axiosInstance.patch(
        `/termset/update/${rowData.term_id}`,
        {
          // business_partner_id: 1,
          term_name: formData.term_name,
          term_desc: formData.term_desc,
         status: formData?.status === true ? 1 : 0,

        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        },
      );

      // Success message after API call
      Swal.fire({
        title: "Success!",
        text: "Termset updated successfully.",
        icon: "success",
        confirmButtonText: "OK",
      }).then(() => {
        // Navigate after success
        navigate(ROUTES_NAVIGATION.TERMLIST);
      });
    } catch (error) {
      // Error alert in case of failure
      Swal.fire({
        title: "Error!",
        text: "Failed to update the termset. Please try again.",
        icon: "error",
        confirmButtonText: "OK",
      });
    } finally {
      setIsLoading(false); // Always reset loading state at the end
    }
  };

  useEffect(() => {
    fetchTermset();
  }, []);

  const fetchTermset = async () => {
    try {
      const response = await axiosInstance.get(
        `/termset/edit/${rowData.term_id}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        },
      );
      const fetchedData = response.data.data;
      const formatedData = {
        term_name: fetchedData.term_name,
        term_desc: fetchedData.term_desc,
        status:
       fetchedData.status === true || fetchedData.status === 1 || fetchedData.status === "1"
       ? 1
       : fetchedData.status === false || fetchedData.status === 0 || fetchedData.status === "0"
       ? 0
       : null,
        business_partner_id: fetchedData.business_partner_id,
      };
      setFormData(formatedData);
      setEditTermset(fetchedData);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div>
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <div className="backbutton mt-2 mb-2">
            <img onClick={() => navigate(-1)} src={backicon} alt="back" />
            <span className="backbtntitle">Update New Term</span>
          </div>
          <div className="form-container">
            <span className="cust-det-title mt-2 mb-2">
              Please Enter Term Details
            </span>
            <DynamicForm
              formConfig={TermInputs}
              formData={formData}
              setFormData={setFormData}
              onSubmit={handleFormSubmit}
              validationErrors={validationErrors}
              setValidationErrors={setValidationErrors}
            />
          </div>
          <div className="btncontainer mt-3">
            <button
              className="submit-btn"
              disabled={
                !isFormValid(TermInputs, formData, validationErrors) ||
                isLoading
              }
              style={buttonStyle(
                TermInputs,
                formData,
                validationErrors,
                isLoading,
              )}
              onClick={() => {
                if (!isFormSubmitted) {
                  handleFormSubmit(formData);
                }
              }}
            >
              {isLoading ? "Processing..." : "Submit"}
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default EditTerm;
